module.exports = __webpack_public_path__ + "static/img/correct.bd9ac242.png";